<div>
    <form [formGroup]="casoUsoGroup" autocomplete="off">
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> T&iacute;tulo:</mat-label>
                    <textarea aria-label="Título:" formControlName='tituloCtrl' maxlength="200" matInput placeholder="Titulo:"
                        [(ngModel)]="objetoCasosDeUso.nombre"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> Descripci&oacute;n: </mat-label>
                    <textarea aria-label="Descripción:" formControlName='descripcionCtrl' maxlength="500" matInput placeholder="Descripción"
                        [(ngModel)]="objetoCasosDeUso.descripcion"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> Actores </mat-label>
                    <textarea aria-label="Actores" formControlName='actoresCtrl' maxlength="200" matInput placeholder="Actores "
                        [(ngModel)]="objetoCasosDeUso.actores"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> Precondiciones</mat-label>
                    <textarea aria-label="Precondiciones" formControlName='precondicionesCtrl' maxlength="300" matInput
                        placeholder="Precondiciones " [(ngModel)]="objetoCasosDeUso.precondiciones"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label>Flujo Primario</mat-label>
                    <textarea aria-label="Flujo Primario" formControlName='flujoPrimarioCtrl' maxlength="500" matInput placeholder="Flujo Primario"
                        [(ngModel)]="objetoCasosDeUso.flujo_primario"></textarea>
                </mat-form-field>
            </div>
        </div>
    </form>


    <div class="row">
        <h6><mat-icon>account_tree</mat-icon>Flujo(s) Alterno(s)</h6>
        <div style="display: flex; justify-content: center;">
            <mat-form-field>
                <mat-label>Flujo</mat-label>
                <input aria-label="Flujo" matInput placeholder="Flujo(s) Alterno(s) " autocomplete="off" type="text"
                    [(ngModel)]="flujoAlterno.descripcion" maxlength="200">
            </mat-form-field>
            <mat-form-field style="margin-left: 1rem;">
                <mat-label> CU </mat-label>
                <mat-select placeholder="CU" required [(ngModel)]="flujoAlterno.flujo_alterno">
                    <mat-option *ngFor="let caso of listaCasosUso" [value]="caso.id">
                        {{ caso.nombre }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-raised-button type="button" (click)="agregarFlujo()"
                class="btn btn-just-icon btn-round btn btn-primary"
                [disabled]="flujoAlterno.flujo_alterno == undefined || flujoAlterno.flujo_alterno == null">
                <i class="material-icons">add</i>
            </button>
        </div>
    </div>
    <div>
        <label style="font-weight: bold;">Lista de flujos alternos</label>
    </div>
    <ul class="m-0 p-0">
    <li class="row" *ngFor="let flujo of flujosAlterno; let i = index; ">
        <div style="display: flex; justify-content: space-between;">
            <label> Flujo {{i+1}}.- {{flujo.descripcion}} <strong>{{flujo.nombre}} : {{flujo.flujo_alterno}}</strong>
            </label>
            <button mat-raised-button type="button" (click)="editarFlujo(flujo)"
                class="btn btn-just-icon btn-round btn btn-primary">
                <i class="material-icons">edit</i>
            </button>
        </div>
    </li>
    </ul>
    <div *ngIf="flujosAlterno.length == 0">
        <label>No hay Flujos alterno en la lista</label>
    </div>
    <form [formGroup]="casoUsoGroup">
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> Pos condiciones </mat-label>
                    <textarea aria-label="Pos condiciones" formControlName='posCondicionesCtrl' maxlength="500" matInput
                        placeholder="Pos condiciones" [(ngModel)]="objetoCasosDeUso.pos_condiciones"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> Reglas de negocio </mat-label>
                    <textarea aria-label="Reglas de negocio" formControlName='reglasNegocioCtrl' maxlength="700" matInput
                        placeholder="Reglas de negocio" [(ngModel)]="objetoCasosDeUso.reglas_negocio"></textarea>
                </mat-form-field>
            </div>
        </div>
    </form>

    <div class="row">
        <h6><mat-icon>description</mat-icon>Productos de salida</h6>
        <div style="display: flex; justify-content: center;">
            <mat-form-field>
                <mat-label>Producto</mat-label>
                <input aria-label="Producto" matInput placeholder="Producto" autocomplete="off" type="text"
                    [(ngModel)]="productosSalida.descripcion" maxlength="100">
            </mat-form-field>
            <button mat-raised-button type="button" (click)="agregarProductoSalida()"
                class="btn btn-just-icon btn-round btn btn-primary"
                [disabled]="productosSalida.descripcion == undefined || productosSalida.descripcion == null">
                <i class="material-icons">add</i>
            </button>
        </div>
    </div>
    <div>
        <label style="font-weight: bold;">Lista de Productos de Salida</label>
    </div>
    <ul class="m-0 p-0">
    <li class="row" *ngFor="let productos of listProductoSalida; let i = index; ">
        <div style="display: flex; justify-content: space-between;">
            <label> Producto {{i+1}}.- {{productos.descripcion}} </label>
            <button mat-raised-button type="button" (click)="editarProductoSalida(productos)"
                class="btn btn-just-icon btn-round btn btn-primary">
                <i class="material-icons">edit</i>
            </button>
        </div>
    </li>
    </ul>
    <div *ngIf="listProductoSalida.length == 0">
        <label>No hay Productos en la lista</label>
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="casoUsoGroup">
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label> Premisas </mat-label>
                <textarea aria-label="Premisas" formControlName='premisasCtrl' maxlength="300" matInput placeholder="Premisas"
                    [(ngModel)]="objetoCasosDeUso.premisas"></textarea>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field appearance="outline">
                <mat-label> Responsable </mat-label>
                <mat-select name="empleadoResponsable" placeholder="Elige empleado" 
                formControlName="responsableCtrl"
                    [(ngModel)]="objetoCasosDeUso.responsable">
                    <ngx-mat-select-search [formControl]="formCliente"
                    [placeholderLabel]="'Buscar empleado'"
                    [noEntriesFoundLabel]="'No existe empleado'"
                    (click)="clearNombreCli()" (keydown.enter)="$event.target === $event.currentTarget ? clearNombreCli() : null"></ngx-mat-select-search>
                    <mat-option *ngFor="let item of listaDEmpleados"
                        [value]="item.usuario.id">{{item.persona.nombreCompleto}}</mat-option>
                </mat-select>
                <button mat-button matSuffix (click)="clearNombreCli()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <button mat-button class="btn  btn-success" [disabled]="casoUsoGroup.invalid" (click)="guardarCu()">
                    Guardar <i class='material-icons'> save </i>
                </button>
            </div>
        </div>
    </form>
</div>